import React from "react"
import { Asset, Link } from "../../../plugins/gatsby-plugin-atollon"
import StructuredText from "../structured-text/custom-structured-text-renderer"
import {HigherGround, Bambu, Token, Terrace, Cheri, Dundas, Stringers, TopPaddock, DarlingVenue, KB, Observatory} from "../icons"

const VenueCard = (props) => {
  return (
    <Link to={props.permalink} className='card card--venue' data-sal='slide-up' data-sal-duration='1000' data-sal-easing='ease'>
      <div className={`card--venue__logo card--venue-${props.slug}`}>
        {
          (() => {
            switch (props.title) {
              case 'Higher Ground':
                return <HigherGround />;
              case 'The Terrace':
                return <Terrace/>
              case 'Top Paddock':
                return <TopPaddock />;
              case 'Kettle Black':
                return <KB />;
              case 'Token':
                return <Token />;
              case 'Darling Cafe':
                return <DarlingVenue />;
              case 'Dundas & Faussett':
                return <Dundas />;
              case 'Bambu':
                return <Bambu />;
              case 'Stringers':
                return <Stringers />;
              case 'Cheri':
                return <Cheri />;
              case 'The Observatory':
                return <Observatory />;
              default:
                return <HigherGround />;
            }
          })()
        }
      </div>
      {props.featuredImage && <Asset asset={props.featuredImage} />}
      {props.location && <StructuredText data={props.location} />}
      {props.phone && <Link to={`tel:${props.phone}`}>{props.phone}</Link>}
      {props.email && <Link to={`mailto:${props.email}`}>{props.email}</Link>}
    </Link>
  )
}

export default VenueCard